import { render, staticRenderFns } from "./WannasornCoursePriceAndLearnDurationForm.vue?vue&type=template&id=59844b72&scoped=true"
import script from "./WannasornCoursePriceAndLearnDurationForm.vue?vue&type=script&lang=js"
export * from "./WannasornCoursePriceAndLearnDurationForm.vue?vue&type=script&lang=js"
import style0 from "./WannasornCoursePriceAndLearnDurationForm.vue?vue&type=style&index=0&id=59844b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59844b72",
  null
  
)

export default component.exports